import { GridColDef, GridColumnHeaderParams } from '@mui/x-data-grid-premium'
import { Stack, Typography } from '@mui/material'
import { theme, TableCell } from '@ketch-com/deck'

export function transformApiDataToRows(apiData: any[]): RightRow[] {
  if (!Array.isArray(apiData)) return []

  return apiData.map((item, index) => ({
    id: item.rightCode || `row-${index}`,
    right: item.rightName || '',
    code: item.rightCode || '',
    total: item.total ?? 0,
    complete: item.complete ?? 0,
    rejected: item.rejected ?? 0,
    duplicates: item.duplicates ?? 0,
    fulfilledOnTime: item.fulfilledOnTime != null ? `${item.fulfilledOnTime}%` : '0%',
    meanFulfillmentTime: item.avgFulfilTime != null ? `${item.avgFulfilTime} days` : '0 days',
    medianFulfillmentTime: item.medianFulfilTime != null ? `${item.medianFulfilTime} days` : '0 days',
    volumeDistribution:
      typeof item.volumeDistribution === 'number' ? `${(item.volumeDistribution / 10).toFixed(1)}%` : '0%',
    overdue: item.overdue ?? 0,
    dueToday: item.dueOneDay ?? 0,
    dueSoon: item.dueSoon ?? 0,
    onTrack: item.onTrack ?? 0,
  }))
}

export interface RightRow {
  id: string
  right: string
  code: string
  total: number
  complete: number
  rejected: number
  duplicates: number
  fulfilledOnTime: string
  meanFulfillmentTime: string
  medianFulfillmentTime: string
  volumeDistribution: string
  overdue: number
  dueToday: number
  dueSoon: number
  onTrack: number
}

export const liveRightsDataGridColumns: GridColDef<RightRow>[] = [
  {
    align: 'left',
    field: 'right',
    headerName: 'Right',
    flex: 3,
    headerAlign: 'left',
    sortable: true,
    renderHeader: (params: GridColumnHeaderParams<RightRow>) => (
      <Typography variant="smallLabel" color={theme.palette.Text.Secondary}>
        Right
      </Typography>
    ),
    renderCell: params => (
      <TableCell>
        <Stack>
          <Typography variant="label">{params.row.right || params.row.code}</Typography>
          {params.row.right && (
            <Typography variant="body" color={theme.palette.Text.Secondary}>
              {params.row.code}
            </Typography>
          )}
        </Stack>
      </TableCell>
    ),
  },
  {
    align: 'left',
    field: 'total',
    headerName: 'Total',
    flex: 1,
    headerAlign: 'left',
    sortable: true,
    renderHeader: (params: GridColumnHeaderParams<RightRow>) => (
      <Typography variant="smallLabel" color={theme.palette.Text.Secondary}>
        Total
      </Typography>
    ),
    renderCell: params => (
      <TableCell>
        <Typography variant="body">{params.value.toLocaleString()}</Typography>
      </TableCell>
    ),
  },
  {
    align: 'left',
    field: 'overdue',
    headerName: 'Overdue',
    flex: 1,
    headerAlign: 'left',
    sortable: true,
    renderHeader: (params: GridColumnHeaderParams<RightRow>) => (
      <Typography variant="smallLabel" color={theme.palette.Text.Secondary}>
        Overdue
      </Typography>
    ),
    renderCell: params => (
      <TableCell>
        <Typography variant="body">{params.value}</Typography>
      </TableCell>
    ),
  },
  {
    align: 'left',
    field: 'dueToday',
    headerName: 'Due Today',
    flex: 1,
    sortable: true,
    renderHeader: (params: GridColumnHeaderParams<RightRow>) => (
      <Typography variant="smallLabel" color={theme.palette.Text.Secondary}>
        Due Today
      </Typography>
    ),
    renderCell: params => (
      <TableCell>
        <Typography variant="body">{params.value}</Typography>
      </TableCell>
    ),
  },
  {
    align: 'left',
    field: 'dueSoon',
    headerName: 'Due Soon',
    flex: 1,
    headerAlign: 'left',
    sortable: true,
    renderHeader: (params: GridColumnHeaderParams<RightRow>) => (
      <Typography variant="smallLabel" color={theme.palette.Text.Secondary}>
        Due Soon
      </Typography>
    ),
    renderCell: params => (
      <TableCell>
        <Typography variant="body">{params.value}</Typography>
      </TableCell>
    ),
  },
  {
    align: 'left',
    field: 'onTrack',
    headerName: 'On Track',
    flex: 1.2,
    headerAlign: 'left',
    sortable: true,
    renderHeader: (params: GridColumnHeaderParams<RightRow>) => (
      <Typography variant="smallLabel" color={theme.palette.Text.Secondary}>
        On Track
      </Typography>
    ),
    renderCell: params => (
      <TableCell>
        <Typography variant="body">{params.value}</Typography>
      </TableCell>
    ),
  },
  {
    align: 'left',
    field: 'volumeDistribution',
    headerName: 'Volume Distribution',
    flex: 1.2,
    headerAlign: 'left',
    sortable: true,
    renderHeader: (params: GridColumnHeaderParams<RightRow>) => (
      <Typography variant="smallLabel" color={theme.palette.Text.Secondary}>
        Volume Distribution
      </Typography>
    ),
    renderCell: params => (
      <TableCell>
        <Typography variant="body">{params.value}</Typography>
      </TableCell>
    ),
  },
]
